import Emil from './img/Emil.png';
import Evan from './img/Evan.png';
import Hyna from './img/Hyna.png';
import Regan from './img/Regan.png';
import Talisa from './img/Talisa.png';
import Vanny from './img/Vanny.png';
import Flora from './img/Flora.png';

const Developers = [
  {
    image: Emil,
    name: 'Emil Su',
    position: 'Developer Leader',
    bulletPoint1: 'Analyse and Draw ERD and Class Diagram base on System requirements',
    bulletPoint2: 'Participated full-stack development',
    bulletPoint3: 'Holding group meetings and workshops',
    LinkedinURL: 'https://www.linkedin.com/in/emil-su'
  },
  {
    image: Hyna,
    name: 'Hyna Hua',
    position: 'Developer',
    bulletPoint1: 'Lorem, ipsum dolor',
    bulletPoint2: 'Lorem, ipsum dolor',
    bulletPoint3: 'Lorem, ipsum dolor',
    LinkedinURL: 'https://www.linkedin.com/in/hyna-hua/'
  },
  {
    image: Talisa,
    name: 'Talisa Li',
    position: 'Developer',
    bulletPoint1: 'Lorem, ipsum dolor',
    bulletPoint2: 'Lorem, ipsum dolor',
    bulletPoint3: 'Lorem, ipsum dolor',
    LinkedinURL: 'https://www.linkedin.com/in/talisa-li'
  },
  {
    image: Regan,
    name: 'Regan Leung',
    position: 'Developer',
    bulletPoint1: 'Lorem, ipsum dolor',
    bulletPoint2: 'Lorem, ipsum dolor',
    bulletPoint3: 'Lorem, ipsum dolor',
    LinkedinURL: 'https://www.linkedin.com/in/regan-leung/'
  },
  {
    image: Evan,
    name: 'Evan Lin',
    position: 'Developer',
    bulletPoint1: 'Lorem, ipsum dolor',
    bulletPoint2: 'Lorem, ipsum dolor',
    bulletPoint3: 'Lorem, ipsum dolor',
    LinkedinURL: 'https://www.linkedin.com/in/evan-lindw'
  },
  {
    image: Vanny,
    name: 'Vanny Qi',
    position: 'Developer',
    bulletPoint1: 'Lorem, ipsum dolor',
    bulletPoint2: 'Lorem, ipsum dolor',
    bulletPoint3: 'Lorem, ipsum dolor',
    LinkedinURL: 'https://www.linkedin.com/in/shaojuan-qi-b64472235/'
  },
  {
    image: Flora,
    name: 'Flora Meng',
    position: 'Developer',
    bulletPoint1: 'Lorem, ipsum dolor',
    bulletPoint2: 'Lorem, ipsum dolor',
    bulletPoint3: 'Lorem, ipsum dolor',
    LinkedinURL: 'https://www.linkedin.com/in/flora-meng'
  }
];

export default Developers;
